import React from "react";
import { Box } from "@origin-digital/ods-core";

import NavSection from "../NavSection/NavSection";
import { HeaderProfile } from "../HeaderProfile/";
import { pageHeaderHeight, pageHeaderZIndex } from "src/constants";
import { useShouldShowPrivateElements } from "./useShouldShowPrivateElements";

export const HeaderBar = () => {
  const shouldShowPrivateElements = useShouldShowPrivateElements();
  return (
    <Box
      style={{
        zIndex: pageHeaderZIndex,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: pageHeaderHeight,
      }}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="full"
      paddingX={shouldShowPrivateElements ? "large" : "xsmall"}
      backgroundColor="white"
    >
      <NavSection shouldShowPrivateElements={shouldShowPrivateElements} />
      {shouldShowPrivateElements && <HeaderProfile />}
    </Box>
  );
};
